import { Accordion, AccordionSummary, Button, Stack, styled, Typography } from '@ethings/ui-toolkit';
import { useTheme } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../icons';
import { useHistorySearch } from './use-history-search';

interface Props {
  entityId: string;
}

const StyledAccordion = styled(Accordion)({
  marginTop: '8px',
  padding: 0,
  boxShadow: 'none',
  '& .MuiAccordionSummary-root': { minHeight: 'fit-content', padding: 0 },
  '& .MuiAccordionSummary-root.Mui-expanded': { margin: 0, minHeight: 'fit-content', padding: 0 },
  '& .MuiAccordionSummary-root.Mui-focusVisible': { backgroundColor: 'transparent !important' },
  '& .MuiAccordionDetails-root': { padding: 0 },
});

const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  cursor: 'default !important',
  flexDirection: 'row-reverse',
  marginBottom: `${theme.spacing(2)}`,
  '& .MuiAccordionSummary-content.Mui-expanded': { margin: 0 },
  '& .MuiAccordionSummary-content': {
    justifyContent: 'space-between',
    margin: 0,
    padding: 0,
  },
}));

export const JourneyInstanceNoDate: FC<Props> = ({ entityId }) => {
  const theme = useTheme();
  const { openAddDateTimePicker } = useHistorySearch();
  const { t } = useTranslation(['common']);

  return (
    <StyledAccordion
      expanded={false}
    >
      <StyledAccordionSummary expandIcon={<></>}>
        <Stack direction="column" spacing={1}>
          <Stack
            alignItems="center"
            direction="row"
            spacing={2}
          >
            <Icon icon="MapPin" style={{ color: theme.palette.text.secondary }} />
            <Button data-testid='history-set-date-range' onClick={() => openAddDateTimePicker(entityId)}>
              <Typography>{t('common:component.entity-journey.action.set-date-range')}</Typography>
            </Button>
          </Stack>
        </Stack>
      </StyledAccordionSummary>
    </StyledAccordion>
  );
};
